import React, {FC, createContext, useContext} from 'react'
import {dataDivisionsForLogin, getJsonLabelMultiLanguage} from '../../app/utils'
import {getCommonCode} from '../../app/modules/auth/apis'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

type Props = {
  selectedLang: 'en' | 'vi' | 'jp'
}
const initialState: Props = {
  selectedLang: 'vi',
}

function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  return initialState
}

// Side effect
export function setLanguage(lang: string) {
  localStorage.removeItem('multi-lang-json')
  localStorage.removeItem('CommonCode')
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
  apiGetConfigMultiLanguage(lang.toLocaleUpperCase(), '2')
    getCommonCode(lang)
    .then((res: any) => {
      var program: any[] = []
      res.commonCode.map((o: any) => {
        let obj = {
          value: o.code,
          label: o.name,
          type: o.type,
        }
        program.push(obj)
      })
      program.sort((a, b) => a.type - b.type).sort((a, b) => a.value - b.value)
      localStorage.setItem('CommonCode', JSON.stringify(program))
      apiGetDataDivisionsForLogin(lang)
    })
    .catch((error) => {
      return
    })
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

export function apiGetConfigMultiLanguage(languageCode: string, applicationType: string) {
  getJsonLabelMultiLanguage(languageCode, applicationType).then((res: any) => {
    if (res && !res.isError) {
      localStorage.setItem('multi-lang-json', JSON.stringify(res.result))
    }
  })
}

export function apiGetDataDivisionsForLogin(lang: string) {
  const user = localStorage.getItem('persist:root')
  const user_parse = user ? JSON.parse(user) : ''

  let data = {
    userId: user_parse.userId.replaceAll('"', ''),
    companyId: user_parse.companyId.replaceAll('"', ''),
    isGetMenu: true,
    languageCode: lang.toLocaleUpperCase(),
  }
  dataDivisionsForLogin(data).then((res: any) => {
    if (res && !res.isError) {
      res.result.menuDtos.map((o: any) => {
        if (o.childrens?.length == 0) delete o.childrens
        else {
          o.childrens?.map((o: any) => {
            o.hasBullet = true
            o.closeMenu = true
          })
        }
      })
      localStorage.setItem('menu', JSON.stringify(res.result.menuDtos))
      window.location.reload()
    }
  })
}

type MetroProps = {
  children?: React.ReactNode
}


const MetronicI18nProvider: FC<MetroProps> = ({children}) => {
  const lang = getConfig()
  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang, getConfig}
